import {
    AppBar,
    Box,
    Toolbar,
    Typography,
    Container,
    Button,
    TextField,
    Tab, Tabs, Divider
} from "@mui/material";
import MainIcon from "../icon/FireGrip";
import Gooogle from "../icon/Gooogle";
import Footbar from "../panel/Footbar";
import { useState } from "react";
import { doSignInWithGoogle, handleLogin, handleLogup, handleForgot, handleAuthChange, handleSendPasswordResetEmail } from "../config/firebase";
import { useEffect } from "react";
import Notification from "../utils/Notification";
import { useRef } from "react";

function Login() {
  const notificationRef = useRef();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [currentTab, setCurrentTab] = useState(0);
  const [isEmailVerificationPending, setIsEmailVerificationPending] = useState(false);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  }

  const handleSignin = async () => {
    try{
      var res = await handleLogin(email, password);
      var emailVerified = res.user?.emailVerified;
      if (!emailVerified) {
        handleAlertOpen("warning", "Please Verify Your Email");
        setIsEmailVerificationPending(true);
      } else {
        handleAlertOpen("success", "Login Successful");
      }
    } catch(error) {
      let userNotFound = error.message.indexOf("user-not-found");
      if (userNotFound > -1) {
        handleAlertOpen("error", "User Not Found");
        return;
      }
      let wrongPassword = error.message.indexOf("wrong-password");
      if (wrongPassword > -1) {
        handleAlertOpen("error", "Wrong Password");
        return;
      }
      handleAlertOpen("error", "Failed Login");
    }
  }

  const handleSignup = async () => {
    try{
      var res = await handleLogup(email, password);
      var emailVerified = res.user?.emailVerified;
      if (!emailVerified) {
        setIsEmailVerificationPending(true);
      }
      handleAlertOpen("success", "Registration Successful");
    }
    catch(error){
      handleAlertOpen("error", "Failed Registration");
      return [null, error]
    }
  }

  const handleForgotPassword = async () => {
    try{
      await handleForgot(email);
      handleAlertOpen("success", "Link Sent to Email");
    }
    catch(error){
      handleAlertOpen("error", "Link Not Sent");
      return [null, error]
    }
  }

  const sendVerificationEmail = async () => {
    try{
      await handleSendPasswordResetEmail(email);
      handleAlertOpen("success", "Link Sent to Email");
    }
    catch(error){
      handleAlertOpen("error", "Link Not Sent");
      return [null, error]
    }
  }

  const handleAlertOpen = (severity, text) => {
    notificationRef.current.openPopup(severity, text)
  };

  useEffect(() => {
    handleAuthChange((user) => {
      if (user && !user.emailVerified) {
        setEmail(user.email);
        setIsEmailVerificationPending(true);
      }
    });
  })

  return (
    <Box>
      <AppBar position="static">
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <MainIcon sx={{ display: "flex", mr: 1 }} color="white" />
            <Typography
              variant="h5"
              noWrap
              component="a"
              href="#app-bar-with-responsive-menu"
              sx={{
                mr: 2,
                display: "flex",
                flexGrow: { xs: 1, md: "initial" },
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
              }}
            >
              Notebook
            </Typography>
          </Toolbar>
        </Container>
      </AppBar>
      <Box sx={{ minHeight: "75vh" }}>

        <Container component="main" maxWidth="xs">

          <Box
            sx={{
              marginTop: 8,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Tabs value={currentTab} onChange={handleTabChange} centered>
              <Tab label="Login" disabled={isEmailVerificationPending} />
              <Tab label="Register" disabled={isEmailVerificationPending} />
              <Tab label="Forgot" disabled={isEmailVerificationPending} />
            </Tabs>
            <TextField
              margin="normal"
              required={!isEmailVerificationPending}
              fullWidth
              label={isEmailVerificationPending ? email : "Email Address"}
              autoComplete="email"
              autoFocus
              defaultValue={email}
              disabled={isEmailVerificationPending}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              margin="normal"
              required={currentTab !== 2 && !isEmailVerificationPending}
              fullWidth
              label="Password"
              type="password"
              defaultValue={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              disabled={currentTab === 2 || isEmailVerificationPending}
            />
            {
              currentTab === 0 && !isEmailVerificationPending &&
              <Button
                fullWidth
                variant="contained"
                onClick={() => handleSignin()}
                sx={{ mt: 3, mb: 2 }}
              >
                Sign In
              </Button>
            }
            {
              currentTab === 1 && !isEmailVerificationPending &&
              <Button
                fullWidth
                color="secondary"
                variant="contained"
                onClick={() => handleSignup()}
                sx={{ mt: 3, mb: 2 }}
              >
                Register
              </Button>
            }
            {
              currentTab === 2 && !isEmailVerificationPending &&
              <Button
                fullWidth
                color="warning"
                variant="contained"
                onClick={() => handleForgotPassword()}
                sx={{ mt: 3, mb: 2 }}
              >
                Forgot Password
              </Button>
            }
            {
              isEmailVerificationPending &&
              <Button
                fullWidth
                color="success"
                variant="contained"
                onClick={() => sendVerificationEmail()}
                sx={{ mt: 3, mb: 2 }}
              >
                Send Email Verification
              </Button>
            }
            <Divider sx={{width: "100%", color: "black", mt: 1}}>OR</Divider>
            <Button sx={{ mt: 1 }} variant="outlined"
              onClick={() => doSignInWithGoogle()}
              startIcon={<Gooogle />}>
              Login with Google
            </Button>
          </Box>
        </Container>
      </Box>
      <Box sx={{ backgroundColor: "#e3f2fd", minHeight: "15vh" }}>
        <Footbar />
      </Box>
      <Notification ref={notificationRef} />
    </Box>
  );
}
export default Login;
